
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const ListagemCheckpoints = () => {
  const [checkpoints, setCheckpoints] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);
  const { parametros } = useCliente();

  useEffect(() => {
    const carregarCheckpoints = async () => {
      try {
        const user_id = localStorage.getItem("user_id");
        if (!user_id || isNaN(Number(user_id))) {
          throw new Error("ID do usuário inválido ou não encontrado no localStorage.");
        }

        const response = await axios.get(`/api/checkpoints_publicados/usuario/${user_id}`);
        setCheckpoints(response.data);
      } catch (error) {
        console.error("Erro ao carregar checkpoints:", error);
        setErro("Erro ao carregar checkpoints. Verifique se você está logado.");
      } finally {
        setCarregando(false);
      }
    };

    carregarCheckpoints();
  }, []);

  const agora = new Date();

  const ativos = checkpoints.filter((cp) => {
    const dataPublicacao = new Date(cp.data_publicacao);
    const expiraEm = new Date(dataPublicacao.getTime() + cp.tempo_resposta * 60000);
    return expiraEm > agora;
  });

  const finalizados = checkpoints.filter((cp) => {
    const dataPublicacao = new Date(cp.data_publicacao);
    const expiraEm = new Date(dataPublicacao.getTime() + cp.tempo_resposta * 60000);
    return expiraEm <= agora;
  });

  const renderTabela = (titulo, dados) => (
    <div className="card mb-4 shadow rounded">
      <div style={{ fontSize: "18px", fontWeight: "bold", marginTop: "18px", marginBottom: "8px" }}>
        {titulo}
      </div>
      <div className="table-wrapper">
        {dados.length === 0 ? (
          <p className="text-muted">Nenhum checkpoint encontrado.</p>
        ) : (
          <table className="tabela" style={{ tableLayout: "fixed", width: "100%" }}>
            <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white" }}>
              <tr>
                <th style={{ width: "11%" }}>Data</th>
                <th style={{ width: "20%" }}>Turma</th>
                <th style={{ width: "20%" }}>Disciplina</th>
                <th style={{ width: "20%" }}>Sessão</th>
                <th style={{ width: "20%" }}>Pergunta</th>
                <th style={{ width: "9%" }}>Tempo</th>
              </tr>
            </thead>
            <tbody>
              {dados.map((cp) => (
                <tr key={cp.id}>
                  <td>{new Date(cp.data_publicacao).toLocaleString("pt-BR")}</td>
                  <td>{cp.nome_turma}</td>
                  <td>{cp.nome_disciplina}</td>
                  <td>{cp.nome_sessao}</td>
                  <td>{cp.texto_checkpoint}</td>
                  <td>{cp.tempo_resposta} min</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Meus CheckPoints Publicados</h2>
      {carregando ? (
        <p>Carregando...</p>
      ) : erro ? (
        <p className="text-danger">{erro}</p>
      ) : (
        <>
          {renderTabela("CheckPoints Ativos", ativos)}
          {renderTabela("CheckPoints Finalizados", finalizados)}
        </>
      )}
    </div>
  );
};

export default ListagemCheckpoints;
